'use client';

import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface ExclamationDecorProps {
  className?: string;
  count?: number;
  /** Use "light-bg" when the hero has a light background so the decor is visible */
  variant?: 'default' | 'light-bg';
}

const positions = [
  { top: '10%', left: '5%', rotate: -15, size: 'text-6xl', opacity: 0.06 },
  { top: '20%', right: '8%', rotate: 12, size: 'text-8xl', opacity: 0.04 },
  { top: '60%', left: '3%', rotate: -8, size: 'text-7xl', opacity: 0.05 },
  { top: '75%', right: '5%', rotate: 20, size: 'text-5xl', opacity: 0.07 },
  { top: '40%', right: '15%', rotate: -25, size: 'text-9xl', opacity: 0.03 },
];

export function ExclamationDecor({ className, count = 5, variant = 'default' }: ExclamationDecorProps) {
  const decorColor = variant === 'light-bg' ? 'text-zibarit-verde-oscuro/10' : 'text-zibarit-bone';
  return (
    <div className={cn('absolute inset-0 overflow-hidden pointer-events-none', className)} aria-hidden="true">
      {positions.slice(0, count).map((pos, i) => (
        <motion.span
          key={i}
          className={cn(
            'absolute font-playfair font-black italic select-none',
            decorColor,
            pos.size,
          )}
          style={{
            top: pos.top,
            left: pos.left,
            right: pos.right,
            opacity: pos.opacity,
          }}
          animate={{
            y: [0, -20, 0],
            rotate: [pos.rotate, pos.rotate + 5, pos.rotate],
          }}
          transition={{
            duration: 15 + i * 3,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        >
          !
        </motion.span>
      ))}
    </div>
  );
}
